require('./vendor/scroller');

(function ($) {
    class LineAnimation {
        constructor(settings) {
            this.inputLineConfig = settings.points;
            this.$element = settings.$element;
            this.stroke = settings.stroke;

            this.state = {
                elementWidth: 0,
                elementHeight: 0,
                pointsConfig: [],
                totalLength: 0
            }

            this.$svgElement = $(document.createElementNS("http://www.w3.org/2000/svg", "svg"));
            this.$svgElement.addClass('line-animation-render');
            this.$polyline = $(document.createElementNS("http://www.w3.org/2000/svg", 'polyline'));
            this.$element.append(this.$svgElement);
            this.$element.css('position', 'relative');

            this.$svgElement.css({
                width: '100%',
                height: '100%',
                position: 'absolute',
                left: 0,
                top: 0,
                overflow: 'visible'
            });

            this.updateSize();
            this.parsedLineConfig = this.parseLineConfig(this.inputLineConfig)
            this.state.totalLength = this.getTotalDistance(this.parsedLineConfig);
            this.$svgElement.append(this.$polyline);
            this.drawPolyline();
            this.setDash(this.parsedLineConfig);

            //console.log(this.state);
        }

        resize() {
            this.updateSize();
            this.state.totalLength = this.getTotalDistance(this.parsedLineConfig);
            this.drawPolyline();
            this.setDash(this.parsedLineConfig);
        }

        getTotalDistance(lineConfig) {
            let totalDistance = 0;

            for (let i = 0; i < lineConfig.length - 1; i++) {
                let widthPxInPercent = this.state.elementWidth / 100;
                let heightPxInPercent = this.state.elementHeight / 100;

                let x1 = lineConfig[i][0] * widthPxInPercent,
                    y1 = lineConfig[i][1] * heightPxInPercent,
                    x2 = lineConfig[i + 1][0] * widthPxInPercent,
                    y2 = lineConfig[i + 1][1] * heightPxInPercent;

                totalDistance += this.getDistance(x1, y1, x2, y2);
            }
            return totalDistance;
        }

        drawPolyline() {
            let self = this;
            let pointsStr = '';

            this.parsedLineConfig.forEach(function (item) {
                pointsStr += self.state.elementWidth / 100 * item[0] + ", " + self.state.elementHeight / 100 * item[1] + " "
            });

            this.$polyline.attr("points", pointsStr);
            this.$polyline.attr("style", "stroke:" + this.stroke + "; stroke-width:" + "1" + "; fill:none"); //Set path's data
        }

        getDistance(x1, y1, x2, y2) {
            var a = x1 - x2;
            var b = y1 - y2;

            return (Math.sqrt(a * a + b * b));
        }

        parseLineConfig(config) {
            let bracket_points_arr = [];
            config.forEach(function (points_str) {
                let brackets_points = points_str.split(', ');

                brackets_points.forEach(function (item) {
                    bracket_points_arr.push(item.split(' '));
                });
            });

            return bracket_points_arr;
        }

        setDash() {
            this.$polyline.attr("stroke-dasharray", this.state.totalLength);
            this.$polyline.attr("stroke-dashoffset", this.state.totalLength);
        }


        setProgress(progress) {
            this.$polyline.attr("stroke-dashoffset", this.state.totalLength - (this.state.totalLength / 100 * progress));
        }

        updateSize() {
            this.state.elementWidth = this.$element.outerWidth();
            this.state.elementHeight = this.$element.outerHeight();
        }
    }


    class CrossSectionLineAnimation {
        constructor(settings) {
            this.state = {
                sectionsConfig: []
            }

            this.initSectionsConfig(settings);
            this.setSectionsHeight(this.state.sectionsConfig);
            this.setTotalHeight(this.getTotalHeight());
            this.setTotalAnimationPercent();
        }

        resize() {
            this.setSectionsHeight(this.state.sectionsConfig);
            this.setTotalHeight(this.getTotalHeight());
            this.setTotalAnimationPercent();
        }

        getTotalHeight() {
            let totalHeight = 0;

            this.state.sectionsConfig.forEach((item) => {
                totalHeight += item.elementHeight;
            })

            return totalHeight;
        }

        setTotalHeight(totalHeight) {
            this.state.totalHeight = totalHeight;
        }

        initSectionsConfig(config) {
            config.forEach((item) => {
                this.state.sectionsConfig.push({
                    $element: item.$element,
                    lineAnimation: item.lineAnimation,
                    progress: 0
                })
            })
        }

        setSectionsHeight(config) {
            config.forEach((item) => {
                item.elementHeight = item.$element.outerHeight()
            })
        }

        setTotalAnimationPercent() {
            this.state.sectionsConfig.forEach((section, index) => {
                section.totalAnimationPercent = section.elementHeight / (this.state.totalHeight / 100);
            })
        }

        setProgress(progress) {
            let localProgress = progress;

            for (let section of this.state.sectionsConfig) {
                if (localProgress === 0) section.progress = 0;

                let progressTo = localProgress / section.totalAnimationPercent * 100;
                section.progress = progressTo > 100 ? 100 : progressTo;

                section.lineAnimation.setProgress(section.progress);

                localProgress = localProgress - section.totalAnimationPercent < 0 ? 0 : localProgress - section.totalAnimationPercent;
            }

        }
    }

    $(window).on('load', function () {
        setTimeout(() => {
            if ($("body").hasClass("home")) {
                initLineAnimation()//HOME PAGE
            }
            if ($("body").hasClass("page-id-9")) {
                initLineAnimation2()//ABOUT PAGE
            }
            initLineAnimation3()//SERVICES PAGE
            initLineAnimation4()//RECYCLE PAGE
            initLineAnimation5()//PROJECTS PAGE
            initLineAnimation6()//CONNECT WITH US PAGE
            initLineAnimation7()//INDUSTRIES PAGE
            initLineAnimation8()//NEWSROOM PAGE
            initLineAnimation9()//CAREERS PAGE
            initLineAnimation10()//WELLSFARGO PAGE
            initLineAnimation11()//UP-RUNNING PAGE
            initLineAnimation12()//FOLLOW_US PAGE
        }, 1000)
    });

    //////////////////////////////////////////////////////////////////////////////
    //HOME PAGE
    //////////////////////////////////////////////////////////////////////////////

    function initLineAnimation() {
        let $section1 = $('.section-who-we-are');
        let $section2 = $('.section-quote-banner .container-outer');
        let $section3 = $('.section-what-we-do');
        let $section4 = $('.section-our-projects .line-animation-container');
        let $section5 = $('.section-management-program .line-animation-container');
        let $section6 = $('.section-have-a-job-form .line-animation-container');

        let lineAnimations = [];

        lineAnimations.push(new LineAnimation({
            $element: $section1,
            stroke: '#888888',
            points: ['80 7, 80 100']
        }))

        lineAnimations.push(new LineAnimation({
            $element: $section2,
            stroke: '#888888',
            points: ['80 0, 80 3, 10 3, 10 100']
        }))

        lineAnimations.push(new LineAnimation({
            $element: $section3,
            stroke: '#888888',
            points: ['10 0, 10 75, 70 75, 70 100']
        }))

        lineAnimations.push(new LineAnimation({
            $element: $section4,
            stroke: '#888888',
            points: ['70 0, 70 100, 10 100']
        }))

        lineAnimations.push(new LineAnimation({
            $element: $section5,
            stroke: '#888888',
            points: ['10 0, 10 100']
        }))

        lineAnimations.push(new LineAnimation({
            $element: $section6,
            stroke: '#888888',
            points: ['10 0, 10 16, 10 16, 26 16']
        }))

        let tweenmaxProgressHelper = {
            progress: 0
        }

        let crossSectionLineAnimation1 = new CrossSectionLineAnimation(
            [
                {
                    $element: $section1,
                    lineAnimation: lineAnimations[0]
                },
                {
                    $element: $section2,
                    lineAnimation: lineAnimations[1]
                },
                {
                    $element: $section3,
                    lineAnimation: lineAnimations[2]
                },
                {
                    $element: $section4,
                    lineAnimation: lineAnimations[3]
                },
                {
                    $element: $section5,
                    lineAnimation: lineAnimations[4]
                },
                {
                    $element: $section6,
                    lineAnimation: lineAnimations[5]
                },
            ]
        );

        $section1.on('hidden.scroller', function (item, progress) {
            if (progress < 50) {
                animateTo(0)
            }
            else {
                animateTo(100)
            }
        })

        $section1.on('visible.scroller progress.scroller', function (item, progress) {
            animateTo(progress);
        })

        function animateTo(progress) {
            TweenMax.to(tweenmaxProgressHelper, 2, {
                progress: progress, onUpdate: () => {
                    crossSectionLineAnimation1.setProgress(tweenmaxProgressHelper.progress);
                }
            })
        }

        $section1.scroller({
            triggerOffset: {
                top: '50vh',
                bottom: '-50vh'
            },
            $elementTo: $section6
        });

        $(window).on('resizeLineAnimationEnd', function () {
            lineAnimations.forEach((animation) => {
                animation.resize();
            })
        })
    }


    //////////////////////////////////////////////////////////////////////////////
    //ABOUT PAGE
    //////////////////////////////////////////////////////////////////////////////

    function initLineAnimation2() {
        let $section1 = $('.section-how-it-all-began');
        let $section2 = $('.section-our-team');
        let $sectionNoLine = $('.section-team-list');
        let $section3 = $('.section-have-a-job-form');

        let lineAnimations = [];

        lineAnimations.push(new LineAnimation({
            $element: $section1,
            stroke: '#888888',
            points: ['85 -20, 85 100']
        }))

        lineAnimations.push(new LineAnimation({
            $element: $section2,
            stroke: '#888888',
            points: ['85 0, 85 107, 85 107, 40 107']
        }))

        lineAnimations.push(new LineAnimation({
            $element: $sectionNoLine,
            stroke: '#ffffff',
            points: ['10 0, 10 100']
        }))

        lineAnimations.push(new LineAnimation({
            $element: $section3,
            stroke: '#888888',
            points: ['15 -25, 15 15, 15 15, 25 15']
        }))

        let tweenmaxProgressHelper = {
            progress: 0
        }

        let crossSectionLineAnimation2 = new CrossSectionLineAnimation(
            [
                {
                    $element: $section1,
                    lineAnimation: lineAnimations[0]
                },
                {
                    $element: $section2,
                    lineAnimation: lineAnimations[1]
                },
                {
                    $element: $sectionNoLine,
                    lineAnimation: lineAnimations[2]
                },
                {
                    $element: $section3,
                    lineAnimation: lineAnimations[3]
                },
            ]
        );

        $section1.on('hidden.scroller', function (item, progress) {
            if (progress < 20) {
                animateTo(0)
            }
            else {
                animateTo(100)
            }
        })

        $section1.on('visible.scroller progress.scroller', function (item, progress) {
            animateTo(progress);
        })

        function animateTo(progress) {
            TweenMax.to(tweenmaxProgressHelper, 2, {
                progress: progress, onUpdate: () => {
                    crossSectionLineAnimation2.setProgress(tweenmaxProgressHelper.progress);
                }
            })
        }

        $section1.scroller({
            triggerOffset: {
                top: '50vh',
                bottom: '-50vh'
            },
            $elementTo: $section3
        });

        $(window).on('resizeLineAnimationEnd', function () {
            lineAnimations.forEach((animation) => {
                animation.resize();
            })
        })
    }


    //////////////////////////////////////////////////////////////////////////////
    //SERVICES PAGE
    //////////////////////////////////////////////////////////////////////////////

    function initLineAnimation3() {
        let $section1 = $('.section-demolition');
        let $section2 = $('.section-our-demolition-services');
        let $section3 = $('.section-our-demolition-services .line-animation-container');
        let $section4 = $('.section-dumpster-rental');
        let $section5 = $('.section-white-boxing');

        let lineAnimations = [];

        lineAnimations.push(new LineAnimation({
            $element: $section1,
            stroke: '#888888',
            points: ['75 -20, 75 95']
        }))
        lineAnimations.push(new LineAnimation({
            $element: $section2,
            stroke: '#888888',
            points: ['75 -5, 10 -5, 10 -5, 10 81']
        }))
        lineAnimations.push(new LineAnimation({
            $element: $section3,
            stroke: '#888888',
            points: ['70 45, 80 45, 80 45, 80 150']
        }))
        lineAnimations.push(new LineAnimation({
            $element: $section4,
            stroke: '#888888',
            points: ['80 30, 80 90, 80 90, 100 90']
        }))

        lineAnimations.push(new LineAnimation({
            $element: $section5,
            stroke: '#888888',
            points: ['18 40, 18 90, 18 90, 60 90, 60 90, 60 100']
        }))

        let tweenmaxProgressHelper = {
            progress: 0
        }

        let crossSectionLineAnimation3 = new CrossSectionLineAnimation(
            [
                {
                    $element: $section1,
                    lineAnimation: lineAnimations[0]
                },
                {
                    $element: $section2,
                    lineAnimation: lineAnimations[1]
                },
                {
                    $element: $section3,
                    lineAnimation: lineAnimations[2]
                },
                {
                    $element: $section4,
                    lineAnimation: lineAnimations[3]
                },
                {
                    $element: $section5,
                    lineAnimation: lineAnimations[4]
                },
            ]
        );

        $section1.on('hidden.scroller', function (item, progress) {
            if (progress < 20) {
                animateTo(0)
            }
            else {
                animateTo(100)
            }
        })

        $section1.on('visible.scroller progress.scroller', function (item, progress) {
            animateTo(progress);
        })

        function animateTo(progress) {
            TweenMax.to(tweenmaxProgressHelper, 2, {
                progress: progress, onUpdate: () => {
                    crossSectionLineAnimation3.setProgress(tweenmaxProgressHelper.progress);
                }
            })
        }

        $section1.scroller({
            triggerOffset: {
                top: '50vh',
                bottom: '-50vh'
            },
            $elementTo: $section5
        });

        $(window).on('resizeLineAnimationEnd', function () {
            lineAnimations.forEach((animation) => {
                animation.resize();
            })
        })
    }

    //////////////////////////////////////////////////////////////////////////////
    //RECYCLE PAGE
    //////////////////////////////////////////////////////////////////////////////

    function initLineAnimation4() {
        let $section1 = $('.section-recycle');
        let $section2 = $('.section-following-organizations-list .line-animation-wrap .line-animation-container');
        let $sectionAdditionalLine = $('.section-following-organizations-list .line-animation-wrap-two .line-animation-container');
        let $section3 = $('.section-reuse-for-donations');
        let $section4 = $('.section-page-parallax-block .line-animation-container');
        let $section5 = $('.section-have-a-job-form .line-animation-wrap .line-animation-container');


        let lineAnimations = [];

        lineAnimations.push(new LineAnimation({
            $element: $section1,
            stroke: '#888888',
            points: ['85 -10, 85 100']
        }))
        lineAnimations.push(new LineAnimation({
            $element: $section2,
            stroke: '#888888',
            points: ['85 0, 85 108, 85 108, 55 108']
        }))
        lineAnimations.push(new LineAnimation({
            $element: $sectionAdditionalLine,
            stroke: '#888888',
            points: ['7 -30, 7 100']
        }))
        lineAnimations.push(new LineAnimation({
            $element: $section3,
            stroke: '#888888',
            points: ['7 0, 7 100']
        }))
        lineAnimations.push(new LineAnimation({
            $element: $section4,
            stroke: '#888888',
            points: ['7 -30, 7 132']
        }))
        lineAnimations.push(new LineAnimation({
            $element: $section5,
            stroke: '#888888',
            points: ['7 -15, 7 17, 7 17, 29 17']
        }))

        let tweenmaxProgressHelper = {
            progress: 0
        }

        let crossSectionLineAnimation4 = new CrossSectionLineAnimation(
            [
                {
                    $element: $section1,
                    lineAnimation: lineAnimations[0]
                },
                {
                    $element: $section2,
                    lineAnimation: lineAnimations[1]
                },
                {
                    $element: $sectionAdditionalLine,
                    lineAnimation: lineAnimations[2]
                },
                {
                    $element: $section3,
                    lineAnimation: lineAnimations[3]
                },
                {
                    $element: $section4,
                    lineAnimation: lineAnimations[4]
                },
                {
                    $element: $section5,
                    lineAnimation: lineAnimations[5]
                },
            ]
        );

        $section1.on('hidden.scroller', function (item, progress) {
            if (progress < 20) {
                animateTo(0)
            }
            else {
                animateTo(100)
            }
        })

        $section1.on('visible.scroller progress.scroller', function (item, progress) {
            animateTo(progress);
        })

        function animateTo(progress) {
            TweenMax.to(tweenmaxProgressHelper, 1.2, {
                progress: progress, onUpdate: () => {
                    crossSectionLineAnimation4.setProgress(tweenmaxProgressHelper.progress);
                }
            })
        }

        $section1.scroller({
            triggerOffset: {
                top: '40vh',
                bottom: '-50vh'
            },
            $elementTo: $section5
        });

        $(window).on('resizeLineAnimationEnd', function () {
            lineAnimations.forEach((animation) => {
                animation.resize();
            })
        })
    }

    //////////////////////////////////////////////////////////////////////////////
    //PROJECTS PAGE
    //////////////////////////////////////////////////////////////////////////////

    function initLineAnimation5() {
        let $section1 = $('.section-projects-overview');


        let lineAnimations = [];

        lineAnimations.push(new LineAnimation({
            $element: $section1,
            stroke: '#888888',
            points: ['80 -10, 80 100']
        }))

        let tweenmaxProgressHelper = {
            progress: 0
        }

        let crossSectionLineAnimation5 = new CrossSectionLineAnimation(
            [
                {
                    $element: $section1,
                    lineAnimation: lineAnimations[0]
                },
            ]
        );

        $section1.on('hidden.scroller', function (item, progress) {
            if (progress < 20) {
                animateTo(0)
            }
            else {
                animateTo(100)
            }
        })

        $section1.on('visible.scroller progress.scroller', function (item, progress) {
            animateTo(progress);
        })

        function animateTo(progress) {
            TweenMax.to(tweenmaxProgressHelper, 2, {
                progress: progress, onUpdate: () => {
                    crossSectionLineAnimation5.setProgress(tweenmaxProgressHelper.progress);
                }
            })
        }

        $section1.scroller({
            triggerOffset: {
                top: '50vh',
                bottom: '-50vh'
            },
            $elementTo: $section1
        });

        $(window).on('resizeLineAnimationEnd', function () {
            lineAnimations.forEach((animation) => {
                animation.resize();
            })
        })
    }

    //////////////////////////////////////////////////////////////////////////////
    //CONNECT WITH US PAGE
    //////////////////////////////////////////////////////////////////////////////

    function initLineAnimation6() {
        let $section1 = $('.section-connect-with-us');

        let lineAnimations = [];

        lineAnimations.push(new LineAnimation({
            $element: $section1,
            stroke: '#888888',
            // points: ['87 -15, 87 13, 35 13']
            points: ['87 -15, 87 13, 87 13, 30 13']
        }))

        let tweenmaxProgressHelper = {
            progress: 0
        }

        let crossSectionLineAnimation6 = new CrossSectionLineAnimation(
            [
                {
                    $element: $section1,
                    lineAnimation: lineAnimations[0]
                },
            ]
        );

        $section1.on('hidden.scroller', function (item, progress) {
            if (progress < 10) {
                animateTo(0)
            }
            else {
                animateTo(100)
            }
        })

        $section1.on('visible.scroller progress.scroller', function (item, progress) {
            animateTo(progress);
        })

        function animateTo(progress) {
            TweenMax.to(tweenmaxProgressHelper, .6, {
                progress: progress, onUpdate: () => {
                    crossSectionLineAnimation6.setProgress(tweenmaxProgressHelper.progress);
                }
            })
        }

        $section1.scroller({
            triggerOffset: {
                top: '50vh',
                bottom: '-100vh'
            },
            $elementTo: $section1
        });

        $(window).on('resizeLineAnimationEnd', function () {
            lineAnimations.forEach((animation) => {
                animation.resize();
            })
        })
    }


    //////////////////////////////////////////////////////////////////////////////
    //INDUSTRIES PAGE
    //////////////////////////////////////////////////////////////////////////////

    function initLineAnimation7() {
        let $section1 = $('.section-industries-overview');

        let lineAnimations = [];

        lineAnimations.push(new LineAnimation({
            $element: $section1,
            stroke: '#888888',
            points: ['75 -15, 75 50, 75 50, 5 50, 5 50, 5 106, 5 106, 25 106']
        }))

        let tweenmaxProgressHelper = {
            progress: 0
        }

        let crossSectionLineAnimation7 = new CrossSectionLineAnimation(
            [
                {
                    $element: $section1,
                    lineAnimation: lineAnimations[0]
                },
            ]
        );

        $section1.on('hidden.scroller', function (item, progress) {
            if (progress < 20) {
                animateTo(0)
            }
            else {
                animateTo(100)
            }
        })

        $section1.on('visible.scroller progress.scroller', function (item, progress) {
            animateTo(progress);
        })

        function animateTo(progress) {
            TweenMax.to(tweenmaxProgressHelper, 2, {
                progress: progress, onUpdate: () => {
                    crossSectionLineAnimation7.setProgress(tweenmaxProgressHelper.progress);
                }
            })
        }

        $section1.scroller({
            triggerOffset: {
                top: '50vh',
                bottom: '-50vh'
            },
            $elementTo: $section1
        });

        $(window).on('resizeLineAnimationEnd', function () {
            lineAnimations.forEach((animation) => {
                animation.resize();
            })
        })
    }


    //////////////////////////////////////////////////////////////////////////////
    //NEWSROOM PAGE
    //////////////////////////////////////////////////////////////////////////////

    function initLineAnimation8() {
        let $section1 = $('.section-news-container');

        let lineAnimations = [];

        lineAnimations.push(new LineAnimation({
            $element: $section1,
            stroke: '#888888',
            points: ['7 -7.5, 7 102, 7 102, 25 102']
        }))

        let tweenmaxProgressHelper = {
            progress: 0
        }

        let crossSectionLineAnimation8 = new CrossSectionLineAnimation(
            [
                {
                    $element: $section1,
                    lineAnimation: lineAnimations[0]
                },
            ]
        );

        $section1.on('hidden.scroller', function (item, progress) {
            if (progress < 20) {
                animateTo(0)
            }
            else {
                animateTo(100)
            }
        })

        $section1.on('visible.scroller progress.scroller', function (item, progress) {
            animateTo(progress);
        })

        function animateTo(progress) {
            TweenMax.to(tweenmaxProgressHelper, 2, {
                progress: progress, onUpdate: () => {
                    crossSectionLineAnimation8.setProgress(tweenmaxProgressHelper.progress);
                }
            })
        }

        $section1.scroller({
            triggerOffset: {
                top: '50vh',
                bottom: '-50vh'
            },
            $elementTo: $section1
        });

        $(window).on('resizeLineAnimationEnd', function () {
            lineAnimations.forEach((animation) => {
                animation.resize();
            })
        })
    }

    //////////////////////////////////////////////////////////////////////////////
    //CAREERS PAGE
    //////////////////////////////////////////////////////////////////////////////

    function initLineAnimation9() {
        let $section1 = $('.section-want-to-work-with-us');

        let lineAnimations = [];

        lineAnimations.push(new LineAnimation({
            $element: $section1,
            stroke: '#888888',
            points: ['80 -25, 80 65, 80 65, 20 65'],
        }))

        let tweenmaxProgressHelper = {
            progress: 0
        }

        let crossSectionLineAnimation9 = new CrossSectionLineAnimation(
            [
                {
                    $element: $section1,
                    lineAnimation: lineAnimations[0]
                },
            ]
        );

        $section1.on('hidden.scroller', function (item, progress) {
            if (progress < 20) {
                animateTo(0)
            }
            else {
                animateTo(100)
            }
        })

        $section1.on('visible.scroller progress.scroller', function (item, progress) {
            animateTo(progress);
        })

        function animateTo(progress) {
            TweenMax.to(tweenmaxProgressHelper, 2, {
                progress: progress, onUpdate: () => {
                    crossSectionLineAnimation9.setProgress(tweenmaxProgressHelper.progress);
                }
            })
        }

        $section1.scroller({
            triggerOffset: {
                top: '50vh',
                bottom: '-60vh'
            },
            $elementTo: $section1
        });

        $(window).on('resizeLineAnimationEnd', function () {
            lineAnimations.forEach((animation) => {
                animation.resize();
            })
        })
    }

    //////////////////////////////////////////////////////////////////////////////
    //SINGLE PROJECT PAGE
    //////////////////////////////////////////////////////////////////////////////

    function initLineAnimation10() {
        let $section1 = $('.section-projects-single-content');
        let $section2 = $('.section-the-details');
        let $section_container = $('.section-other-projects .line-animation-container');
        let $section3 = $('.section-other-projects');

        let lineAnimations = [];

        lineAnimations.push(new LineAnimation({
            $element: $section1,
            stroke: '#888888',
            points: ['80 -20, 80 65, 80 65, 8 65, 8 65, 8 105']
        }))
        lineAnimations.push(new LineAnimation({
            $element: $section2,
            stroke: '#888888',
            points: ['33 5, 80 5, 80 100']
        }))
        lineAnimations.push(new LineAnimation({
            $element: $section_container,
            stroke: '#888888',
            points: ['80 0, 80 75']
        }))
        lineAnimations.push(new LineAnimation({
            $element: $section3,
            stroke: '#888888',
            points: ['17 30, 17 150, 17 150, 32 150']
        }))

        let tweenmaxProgressHelper = {
            progress: 0
        }

        let crossSectionLineAnimation10 = new CrossSectionLineAnimation(
            [
                {
                    $element: $section1,
                    lineAnimation: lineAnimations[0]
                },
                {
                    $element: $section2,
                    lineAnimation: lineAnimations[1]
                },
                {
                    $element: $section_container,
                    lineAnimation: lineAnimations[2]
                },
                {
                    $element: $section3,
                    lineAnimation: lineAnimations[3]
                },
            ]
        );

        $section1.on('hidden.scroller', function (item, progress) {
            if (progress < 10) {
                animateTo(0)
            }
            else {
                animateTo(100)
            }
        })

        $section1.on('visible.scroller progress.scroller', function (item, progress) {
            animateTo(progress);
        })

        function animateTo(progress) {
            TweenMax.to(tweenmaxProgressHelper, 1.5, {
                progress: progress, onUpdate: () => {
                    crossSectionLineAnimation10.setProgress(tweenmaxProgressHelper.progress);
                }
            })
        }

        $section1.scroller({
            triggerOffset: {
                top: '50vh',
                bottom: '-50vh'
            },
            $elementTo: $section3
        });

        $(window).on('resizeLineAnimationEnd', function () {
            lineAnimations.forEach((animation) => {
                animation.resize();
            })
        })
    }

    //////////////////////////////////////////////////////////////////////////////
    //UP-RUNNING PAGE
    //////////////////////////////////////////////////////////////////////////////

    function initLineAnimation11() {
        let $section1 = $('.section-how-it-all-began');

        let lineAnimations = [];

        lineAnimations.push(new LineAnimation({
            $element: $section1,
            stroke: '#888888',
            points: ['85 -20, 85 100']
        }));

        let tweenmaxProgressHelper = {
            progress: 0
        };

        let crossSectionLineAnimation11 = new CrossSectionLineAnimation(
            [
                {
                    $element: $section1,
                    lineAnimation: lineAnimations[0]
                }
            ]
        );

        $section1.on('hidden.scroller', function (item, progress) {
            if (progress < 20) {
                animateTo(0)
            }
            else {
                animateTo(100)
            }
        });

        $section1.on('visible.scroller progress.scroller', function (item, progress) {
            animateTo(progress);
        });

        function animateTo(progress) {
            TweenMax.to(tweenmaxProgressHelper, 2, {
                progress: progress, onUpdate: () => {
                    crossSectionLineAnimation11.setProgress(tweenmaxProgressHelper.progress);
                }
            })
        }

        $section1.scroller({
            triggerOffset: {
                top: '50vh',
                bottom: '-50vh'
            },
            $elementTo: $section1
        });

        $(window).on('resizeLineAnimationEnd', function () {
            lineAnimations.forEach((animation) => {
                animation.resize();
            })
        })
    }


    //////////////////////////////////////////////////////////////////////////////
    //FOLLOW US PAGE
    //////////////////////////////////////////////////////////////////////////////

    function initLineAnimation12() {
        let $section1 = $('.section-what-we-do-1');

        let lineAnimations = [];

        lineAnimations.push(new LineAnimation({
            $element: $section1,
            stroke: '#888888',
            points: ['85 0, 85 107, 85 107, 65 107']
        }))

        let tweenmaxProgressHelper = {
            progress: 0
        }

        let crossSectionLineAnimation12 = new CrossSectionLineAnimation(
            [
                {
                    $element: $section1,
                    lineAnimation: lineAnimations[0]
                },
            ]
        );

        $section1.on('hidden.scroller', function (item, progress) {
            if (progress < 20) {
                animateTo(0)
            }
            else {
                animateTo(100)
            }
        })

        $section1.on('visible.scroller progress.scroller', function (item, progress) {
            animateTo(progress);
        })

        function animateTo(progress) {
            TweenMax.to(tweenmaxProgressHelper, 2, {
                progress: progress, onUpdate: () => {
                    crossSectionLineAnimation12.setProgress(tweenmaxProgressHelper.progress);
                }
            })
        }

        $section1.scroller({
            triggerOffset: {
                top: '50vh',
                bottom: '-50vh'
            }
        });

        $(window).on('resizeLineAnimationEnd', function () {
            lineAnimations.forEach((animation) => {
                animation.resize();
            })
        })
    }


    var resizeLineAnimationEnd;
    $(window).on('resize', function () {
        clearTimeout(resizeLineAnimationEnd);
        resizeLineAnimationEnd = setTimeout(function () {
            $(window).trigger('resizeLineAnimationEnd');
        }, 500);
    });


})(jQuery);


// WEBPACK FOOTER //
// ./src/js/lineAnimation.es6